var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinnersBottomWaveMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 390 66"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M390 52.8C303.333 6.6 86.667 66 0 26.4V0h390z"
})));
export default SvgWinnersBottomWaveMobile;